<template>
  <div class="card">
    <div class="card-heading">
      <slot name="header"></slot>
    </div>
    <div class="customer-row section">
      <div class="customer-label label">
        <slot name="customerLabel"></slot>
      </div>
      <div class="customer-content content">
        {{ customer.firstName }} {{ customer.lastName }}
      </div>
    </div>
    <div class="streetAddress-row section">
      <div class="streetAddress-label label">
        <slot name="streetAddressLabel"></slot>
      </div>
      <div class="streetAddress-content content">
        {{ customer.address.street }} {{ customer.address.houseNumber }}
      </div>
    </div>
    <div class="cityAddress-row section">
      <div class="cityAddress-label label">
        <slot name="cityAddressLabel"></slot>
      </div>
      <div class="cityAddress-content content">
        {{ customer.address.zip }} {{ customer.address.city }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeliveryInfoCard',
  props: {
    customer: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
